import React, { Dispatch, SetStateAction } from "react";
import { Dialog, Table, Button, Heading } from "@blasterjs/core";
import { DialogBody, DialogFooter, DialogHeader } from "../components/DialogLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faMinus,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
}

const KeyboardControl = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const StyledControlIcon = styled(FontAwesomeIcon)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  gap: 10px;
  padding: 4px;
  margin-right: 1rem;
  height: 1em;
  width: 1em;
`;

const StyledControlIconLetter = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  gap: 10px;
  padding: 1px;
  margin-right: 1rem;
  height: 1.35em;
  width: 1.35em;
  font-size: 1.25em;
  font-weight: 500;
`;

const KeyboardShortcutDialog = ({ isOpen, setOpenDialog }: Props) => {
  return (
    <>
      <Dialog isOpen={isOpen} onRequestClose={() => setOpenDialog(false)} width="576px">
        <DialogHeader title="Keyboard Shortcuts" closeDialog={() => setOpenDialog(false)} />
        <DialogBody>
          <Table style={{ width: "100%", textOverflow: "wrap" }}>
            <tbody>
              <tr>
                <td style={{ width: "50%" }}>
                  <Heading as="h5" textAlign="left">
                    Movement Controls
                  </Heading>
                  <KeyboardControl>
                    <StyledControlIcon icon={faArrowUp} /> Pan Up Image
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={faArrowDown} /> Pan Down Image
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={faArrowLeft} /> Pan Left Image
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={faArrowRight} /> Pan Right Image
                  </KeyboardControl>

                  <Heading as="h5" textAlign="left">
                    Magnification Controls
                  </Heading>
                  <KeyboardControl>
                    <StyledControlIcon icon={faPlus} /> Zoom In
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={faMinus} /> Zoom Out
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa1} /> Set Maginification to 1.25x
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa2} /> Set Maginification to 2.5x
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa3} /> Set Maginification to 5x
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa4} /> Set Maginification to 10x
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa5} /> Set Maginification to 20x
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIcon icon={fa6} /> Set Maginification to 40x
                  </KeyboardControl>
                </td>
                <td style={{ width: "50%" }}>
                  <Heading as="h5" textAlign="left">
                    View Controls
                  </Heading>
                  <KeyboardControl>
                    <StyledControlIconLetter>c</StyledControlIconLetter> Open/Close Overlay Elements
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>a</StyledControlIconLetter> Toggle Annotations Display
                  </KeyboardControl>

                  <Heading
                    as="h5"
                    textAlign="left"
                    style={{ marginBottom: "0rem", paddingBottom: "0rem" }}
                  >
                    Annotation Tools
                  </Heading>
                  <p style={{ marginBottom: "0.5rem", marginTop: "0rem", paddingTop: "0rem" }}>
                    Use <span style={{ fontWeight: "bold" }}>up and down arrows</span> to choose
                    from menu items and <span style={{ fontWeight: "bold" }}>Enter</span> to
                    select/apply.
                  </p>
                  <KeyboardControl>
                    <StyledControlIconLetter>i</StyledControlIconLetter> AI Layers (if available)
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>r</StyledControlIconLetter> Ruler Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>l</StyledControlIconLetter> Line Measurement Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>t</StyledControlIconLetter> Comment Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>o</StyledControlIconLetter> Ellipse or Circle Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>h</StyledControlIconLetter> HPF Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>p</StyledControlIconLetter> Point Tool
                  </KeyboardControl>
                  <KeyboardControl>
                    <StyledControlIconLetter>f</StyledControlIconLetter> Freehand Tool
                  </KeyboardControl>
                </td>
              </tr>
            </tbody>
          </Table>
        </DialogBody>
        <DialogFooter>
          <Button
            className="cancel-button"
            mr="auto"
            width="15%"
            onClick={() => setOpenDialog(false)}
          >
            {" "}
            Close{" "}
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default KeyboardShortcutDialog;
